module.exports = __webpack_public_path__ + "img/strength.b7d8a52b.png";